import { useReducer } from "react";
const isServerSide = process.env.TAMAGUI_TARGET === "web" && typeof window === "undefined";
const idFn = () => {
};
function useForceUpdate() {
  return isServerSide ? idFn : useReducer((x) => x + 1, 0)[1];
}
export {
  isServerSide,
  useForceUpdate
};
//# sourceMappingURL=index.mjs.map
